<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '70vw', maxHeight: '90vh' }" [draggable]="false"
    [resizable]="false" (onHide)="closeDialog()">

    <div class="flex items-center justify-center dialog-header">
        Duplicate Leads
        <div class="absolute right-4">
            <div class="flex gap-4">
            <div *ngIf="duplicateData.length > 0">
                    <p-button label="Delete All Duplicates" icon="pi pi-trash" severity="danger" [loading]="deletingAll"
                        [disabled]="deletingAll" (click)="deleteAllDuplicates()"></p-button>
                </div>
            <button (click)="closeDialog()" class="text-white hover:text-gray-300">
                <i class="pi pi-times"></i>
            </button>
            </div>

        </div>
    </div>
    <div class="dialog-content p-6">
        <!-- <ng-template >
          
        </ng-template> -->

        <div class="duplicate-leads-content">
            <div *ngIf="loading" class="flex justify-center items-center py-8">
                <p-progressSpinner></p-progressSpinner>
            </div>

              <!-- <div *ngIf="!loading" class="flex items-center justify-between gap-3">
                <div class="flex items-center gap-3">
                    <i class="pi pi-clone text-2xl"></i>
                    <div>
                        <h3 class="text-xl font-semibold m-0">Find Duplicate Leads</h3>
                        <p class="text-sm text-gray-500 m-0 mt-1">
                            Total Groups: {{ totalDuplicateGroups }} | Leads to Review: {{ totalLeadsToDelete }}
                        </p>
                    </div>
                </div>
                
            </div> -->

            <div *ngIf="!loading && duplicateData.length === 0" class="text-center py-8">
                <i class="pi pi-check-circle text-6xl text-green-500 mb-4"></i>
                <h4 class="text-xl font-semibold mb-2">No Duplicates Found</h4>
                <p class="text-gray-600">All leads are unique. No duplicate records detected.</p>
            </div>

            <div *ngIf="!loading && duplicateData.length > 0" class="space-y-4">
                <div *ngFor="let group of displayedDuplicates; let i = index"
                    class="border rounded-lg overflow-hidden shadow-sm">
                    <!-- Group Header -->
                    <div class="bg-gray-50 p-4 cursor-pointer hover:bg-gray-100 transition-colors"
                        (click)="toggleRow(i.toString())">
                        <div class="flex justify-between items-center">
                            <div class="flex items-center gap-4">
                                <i class="pi"
                                    [ngClass]="isRowExpanded(i.toString()) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                                <div>
                                    <div class="font-semibold text-lg">
                                        <i class="pi pi-envelope text-blue-500 mr-2"></i>{{ group.email || 'No Email' }}
                                        <i class="pi pi-phone text-green-500 ml-4 mr-2"></i>{{ group.phone || 'No Phone'
                                        }}
                                    </div>
                                    <div class="text-sm text-gray-600 mt-1">
                                        <span class="mr-4">
                                            <i class="pi pi-users mr-1"></i>
                                            {{ group.duplicate_count }} Total Records
                                        </span>
                                        <span class="mr-4">
                                            <i class="pi pi-exclamation-triangle mr-1 text-orange-500"></i>
                                            {{ group.duplicates_to_delete }} Duplicates
                                        </span>
                                        <span class="mr-4">
                                            <i class="pi pi-calendar mr-1"></i>
                                            First: {{ formatDate(group.first_created) }}
                                        </span>
                                        <span>
                                            <i class="pi pi-calendar-plus mr-1"></i>
                                            Latest: {{ formatDate(group.last_created) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <p-button icon="pi pi-trash" [rounded]="true" [outlined]="true" size="small"
                                severity="danger" [loading]="isGroupDeleting(group)" [disabled]="isGroupDeleting(group)"
                                pTooltip="Delete this duplicate group" tooltipPosition="left"
                                (click)="deleteDuplicateGroup(group); $event.stopPropagation()"></p-button>
                        </div>
                    </div>

                    <!-- Expanded Lead Details -->
                    <div *ngIf="isRowExpanded(i.toString())" class="p-4 bg-white">
                        <p-table [value]="group.leads" [tableStyle]="{'min-width': '50rem'}">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Lead ID</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Status</th>
                                    <th>Stage</th>
                                    <th>Created Date</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-lead>
                                <tr>
                                    <td>
                                        <span class="font-semibold text-blue-600">#{{ lead.lead_id }}</span>
                                    </td>
                                    <td>{{ getFullName(lead) }}</td>
                                    <td>{{ lead.email || '-' }}</td>
                                    <td>{{ lead.phone || '-' }}</td>
                                    <td>
                                        <span class="px-3 py-1 rounded-full text-xs font-semibold" [ngStyle]="{
                      'background-color': lead.lead_status ? '#E8F5E9' : '#FFF3E0',
                      'color': lead.lead_status ? '#2E7D32' : '#E65100'
                    }">
                                            {{ lead.lead_status || 'No Status' }}
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            class="capitalize px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-semibold">
                                            {{ lead.current_stage || 'N/A' }}
                                        </span>
                                    </td>
                                    <td>{{ formatDate(lead.lead_creation_date) }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

                <!-- Pagination -->
                <div class="flex justify-between items-center mt-6 pt-4 border-t">
                    <div class="text-sm text-gray-600">
                        Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize,
                        duplicateData.length) }} of {{ duplicateData.length }} groups
                    </div>
                    <div class="flex gap-2 items-center">
                        <p-button icon="pi pi-angle-left" [rounded]="true" [outlined]="true" size="small"
                            [disabled]="currentPage === 1" (click)="previousPage()"></p-button>

                        <div class="flex gap-1">
                            <p-button *ngFor="let page of getPaginationArray()" [label]="page.toString()"
                                [rounded]="true" [outlined]="currentPage !== page" size="small"
                                [severity]="currentPage === page ? 'primary' : 'secondary'"
                                (click)="onPageChange(page)"></p-button>
                        </div>

                        <p-button icon="pi pi-angle-right" [rounded]="true" [outlined]="true" size="small"
                            [disabled]="currentPage === totalPages" (click)="nextPage()"></p-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-dialog>